import { GlModal, GlButton } from '@gitlab/ui';
import { __ } from '~/locale';
import runPipelineMixin from '../../mixins/run_pipeline';
export default {
    name: 'MergeFailedPipelineConfirmationDialog',
    i18n: {
        primary: __('Merge unverified changes'),
        cancel: __('Cancel'),
        info: __('The merge checks are incomplete because the latest pipeline failed, the pipeline status cannot be verified, or the merge request target branch was changed. You should run a new pipeline before merging.'),
        confirmation: __('Are you sure you want to attempt to merge?'),
        title: __('Merge unverified changes?')
    },
    components: {
        GlModal,
        GlButton
    },
    mixins: [
        runPipelineMixin
    ],
    props: {
        visible: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'cancel',
        'merge-with-failed-pipeline'
    ],
    methods: {
        hide () {
            this.$refs.modal.hide();
        },
        cancel () {
            this.hide();
            this.$emit('cancel');
        },
        focusCancelButton () {
            this.$refs.cancelButton.$el.focus();
        },
        mergeChanges () {
            this.$emit('merge-with-failed-pipeline');
            this.hide();
        }
    }
};
